export class Flavour {

    private _id: number;
    private _name: string;
    private _description: string;
    private _menu_item_id: number;
    private _price: number;

    constructor() {
        this._id = 0;
        this._name = "";
        this._description = "";
        this._menu_item_id = 0;
        this._price = 0
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get menu_item_id(): number {
        return this._menu_item_id;
    }

    set menu_item_id(value: number) {
        this._menu_item_id = value;
    }


    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }
}